import { createApp } from 'vue'
import App from './App.vue'
import Api from '@/api';
import store from './store'
import router from './router'
import '@/assets/app.scss'
import '@/index.css'
import '@/assets/font/fonts.css'
import 'font-awesome/css/font-awesome.css'
// import Vue3Lottie from 'vue3-lottie'
// import 'vue3-lottie/dist/style.css'
const app = createApp(App);
app.config.globalProperties.$request = Api;
import { createI18n } from "vue-i18n";
import zh from './i18n/zh.json'
import en from './i18n/en.json'

let locale = 'en'
const langJudge = navigator.userLanguage || navigator.language

if (langJudge.includes('zh')) {
  locale = 'zh'
  store.dispatch('setLang', 'zh')
} else {
  locale = 'en'
  store.dispatch('setLang', 'en')
}

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages: {
    'zh': zh,
    'en': en
  }
})

const gtmOptions = {
  id: 'GTM-KT6QNHX',
  enabled: process.env.NODE_ENV === 'production',
  defer: false,
  debug: true,
  loadScript: true,
  vueRouter: router,
  ignoredViews: ['index', 'adminlogin', 'list', 'edit']
}

const toastOptions = {
  position: 'top-right',
  timeout: 1000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
}

let toastInstallPromise = null
const installToast = () => {
  if (!toastInstallPromise) {
    toastInstallPromise = Promise.all([
      import('vue-toastification'),
      import('vue-toastification/dist/index.css')
    ]).then(([{ default: Toast }]) => {
      app.use(Toast, toastOptions)
    })
  }

  return toastInstallPromise
}

const installGtm = async () => {
  const { default: VueGtm } = await import('vue-gtm')
  app.use(VueGtm, gtmOptions)
}

if (process.env.NODE_ENV === 'production') {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(installGtm)
  } else {
    window.setTimeout(installGtm, 0)
  }
}

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth || to.name === 'adminlogin') {
    await installToast()
  }
})

app.use(i18n)
app.use(store)
app.use(router)

app.mount('#app')
